export const SHOW_HIGHLIGHS_ONLY = [
    'Site with Maximum Overdue Critical Equipment Work Orders',
    'Site with Most Downgraded Preventive Barriers',
    'Site with Most Loss of Primary Containment in Past Quarter',
    'Site with Latest Operating Limit Excursion'
]